import { motion, useScroll, useTransform } from "motion/react";
import { useRef } from "react";
import { Link } from "react-router-dom";

const MotionLink = motion(Link);

import mainImage from "../assets/about-1.webp";
import thumbnail1 from "../assets/about-2.webp";
import thumbnail2 from "../assets/about-3.webp";

import mainImage2 from "../assets/about-4.webp";
import thumbnail3 from "../assets/about-6.webp";
import thumbnail4 from "../assets/about-5.webp";

interface AboutSectionProps {
    className?: string;
}




function AboutImages({
    mainImageY,
    thumbnailsY,
}: {
    mainImageY: any;
    thumbnailsY: any;
}) {
    return (
        <div className="w-full min-w-0 xl:min-w-[560px] xl:max-w-[940px] xl:flex-[1.1_1_0]">
            <div
                className="
          grid w-full min-w-0 items-stretch
          grid-cols-1
          gap-4
          sm:grid-cols-[minmax(0,1fr)_minmax(180px,36%)]
          sm:gap-5
          lg:gap-6
        "
            >
                <motion.div
                    style={{ y: mainImageY }}
                    initial={{ opacity: 0, scale: 0.96 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: false, amount: 0.2 }}
                    transition={{ duration: 0.7 }}
                    whileHover={{ scale: 1.01 }}
                    className="
            relative overflow-hidden rounded-2xl
            shadow-[0px_12px_42px_-4px_rgba(24,24,25,0.12),0px_8px_18px_-6px_rgba(24,24,25,0.12)]
            min-h-[320px]
            sm:min-h-[420px]
            md:min-h-[500px]
            lg:min-h-[560px]
            xl:min-h-[700px]
          "
                >
                    <img
                        alt="Hamburguesas Stacy apiladas"
                        className="absolute inset-0 size-full object-cover"
                        src={mainImage}
                    />
                </motion.div>

                <motion.div
                    style={{ y: thumbnailsY }}
                    className="
            grid w-full min-w-0
            grid-cols-1
            gap-4
            sm:grid-rows-2
            sm:gap-5
            lg:gap-6
          "
                >
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.3 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        whileHover={{ scale: 1.02 }}
                        className="
              relative overflow-hidden rounded-2xl
              shadow-[0px_12px_42px_-4px_rgba(24,24,25,0.12),0px_8px_18px_-6px_rgba(24,24,25,0.12)]
              min-h-[180px]
              sm:min-h-[200px]
              md:min-h-[230px]
              lg:min-h-[260px]
              xl:min-h-[338px]
            "
                    >
                        <img
                            alt="Clientes en el mostrador de Stacy"
                            className="absolute inset-0 size-full object-cover"
                            src={thumbnail1}
                        />
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.3 }}
                        transition={{ duration: 0.6, delay: 0.35 }}
                        whileHover={{ scale: 1.02 }}
                        className="
              relative overflow-hidden rounded-2xl
              shadow-[0px_12px_42px_-4px_rgba(24,24,25,0.12),0px_8px_18px_-6px_rgba(24,24,25,0.12)]
              min-h-[180px]
              sm:min-h-[200px]
              md:min-h-[230px]
              lg:min-h-[260px]
              xl:min-h-[338px]
            "
                    >
                        <img
                            alt="Cliente disfrutando hamburguesa Stacy"
                            className="absolute inset-0 size-full object-cover"
                            src={thumbnail2}
                        />
                    </motion.div>
                </motion.div>
            </div>
        </div>
    );
}

function AboutText({ textY }: { textY: any }) {
    return (
        <motion.div
            style={{ y: textY }}
            className="w-full min-w-0 xl:min-w-[560px] xl:max-w-[940px] xl:flex-[0.9_1_0]"
        >
            <div className="flex w-full min-w-0 flex-col items-start justify-center gap-4 text-[#181819] lg:gap-5">
                <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.7, delay: 0.1 }}
                    className="
            w-full min-w-0
            font-['Excessive_Extra_Condensed',sans-serif]
            leading-[0.9]
            not-italic
          "
                >
                    <h2 className="m-0 font-['Excessive_Extra_Condensed'] text-[80px] leading-[0.9] tracking-[0.02em] uppercase sm:text-[112px] md:text-[140px] lg:text-[168px]">
                        <span className="block">ESTA ES NUESTRA HISTORIA</span>
                    </h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.7, delay: 0.25 }}
                    className="
            w-full min-w-0 
            font-['Roboto_Mono',monospace]
            text-[16px] leading-[24px] tracking-[0.32px]
            lg:text-[18px] lg:leading-[30px]
            xl:text-[20px] xl:leading-[32px] xl:tracking-[0.4px]
          "
                >
                    <p className="mb-0">
                        <span >
                            De pibes no necesitábamos mucho. La magia estaba en
                        </span><span className="font-bold"> soñar alto.</span> <span> Pero sobre todo, en<span className="font-bold"> animarse a jugar. </span>
                        </span>
                        <span >
                            En correr hasta que no te dieran las piernas, inventar reglas sobre la marcha, en perder la noción del tiempo hasta que una voz gritaba desde lejos: “¡a comer!”. Y volviamos a casa con las rodillas raspadas y la sonrisa intacta. Eran cosas simples, pero se sentían gigantes. Y sin darnos cuenta, así comenzó todo.
                        </span>

                    </p>

                    <p className="mb-0 mt-4 lg:mt-6">
                        <span>Con el tiempo crecimos. Llegaron los horarios, se instalaron las rutinas, nos ganaron las responsabilidades. Y sin darnos cuenta,
                        </span>
                        <span className="font-bold"> el juego quedó atrás.</span>
                        <span> Hasta que un día nos miramos y dijimos:
                        </span>
                        <span className="font-bold"> ¿y si volvemos a jugar?</span>
                        <span> Sin miedo. Sin estructuras. Pero sobre todo, sin perder eso que nos hacía vibrar.
                        </span>
                    </p>

                    <p className="mb-0 mt-4 lg:mt-6">
                        <span>Así nació Stacy. Entre dos amigos con la
                        </span>
                        <span className="font-bold"> excusa perfecta para volver a jugar.</span>
                        <span> De las ganas de
                        </span>
                        <span className="font-bold"> reunir al equipo,</span>
                        <span> con esas cosquillas antes de arrancar, la adrenalina de cada jugada y la pasión que explota del pechito cuando hacés algo que te gusta de verdad.
                        </span>
                    </p>


                </motion.div>
            </div>
        </motion.div>
    );
}


function AboutImages2({
    mainImage2Y,
    thumbnails2Y,
    className = "",
}: {
    mainImage2Y: any;
    thumbnails2Y: any;
    className?: string;
}) {
    return (
        <div className={`w-full min-w-0 xl:min-w-[560px] xl:max-w-[940px] xl:flex-[1.1_1_0] ${className}`}>
            <div
                className="
          grid w-full min-w-0 items-stretch
          grid-cols-1
          gap-4
          sm:grid-cols-[minmax(0,1fr)_minmax(180px,36%)]
          sm:gap-5
          lg:gap-6
        "
            >
                <motion.div
                    style={{ y: thumbnails2Y }}
                    className="
            grid w-full min-w-0
            grid-cols-1
            gap-4
            sm:grid-rows-2
            sm:gap-5
            lg:gap-6
          "
                >
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.3 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        whileHover={{ scale: 1.02 }}
                        className="
              relative overflow-hidden rounded-2xl
              shadow-[0px_12px_42px_-4px_rgba(24,24,25,0.12),0px_8px_18px_-6px_rgba(24,24,25,0.12)]
              min-h-[180px]
              sm:min-h-[200px]
              md:min-h-[230px]
              lg:min-h-[260px]
              xl:min-h-[248px]
              2xl:min-h-[278px]
            "
                    >
                        <img
                            alt="Clientes en el mostrador de Stacy"
                            className="absolute inset-0 size-full object-cover"
                            src={thumbnail3}
                        />
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.3 }}
                        transition={{ duration: 0.6, delay: 0.35 }}
                        whileHover={{ scale: 1.02 }}
                        className="
              relative overflow-hidden rounded-2xl
              shadow-[0px_12px_42px_-4px_rgba(24,24,25,0.12),0px_8px_18px_-6px_rgba(24,24,25,0.12)]
              min-h-[180px]
              sm:min-h-[200px]
              md:min-h-[230px]
              lg:min-h-[260px]
              xl:min-h-[248px]
              2xl:min-h-[278px]
            "
                    >
                        <img
                            alt="Cliente disfrutando hamburguesa Stacy"
                            className="absolute inset-0 size-full object-cover"
                            src={thumbnail4}
                        />
                    </motion.div>
                </motion.div>

                <motion.div
                    style={{ y: mainImage2Y }}
                    initial={{ opacity: 0, scale: 0.96 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: false, amount: 0.2 }}
                    transition={{ duration: 0.7 }}
                    whileHover={{ scale: 1.01 }}
                    className="
            relative overflow-hidden rounded-2xl
            shadow-[0px_12px_42px_-4px_rgba(24,24,25,0.12),0px_8px_18px_-6px_rgba(24,24,25,0.12)]
            min-h-[320px]
            sm:min-h-[420px]
            md:min-h-[500px]
            lg:min-h-[560px]
            xl:min-h-[520px]
            2xl:min-h-[580px]
          "
                >
                    <img
                        alt="Hamburguesas Stacy apiladas"
                        className="absolute inset-0 size-full object-cover"
                        src={mainImage2}
                    />
                </motion.div>
            </div>
        </div>
    );
}

function AboutText2({
    textY,
    className = "",
}: {
    textY: any;
    className?: string;
}) {
    return (
        <motion.div
            style={{ y: textY }}
            className={`w-full min-w-0 xl:min-w-[560px] xl:max-w-[940px] xl:flex-[0.9_1_0] ${className}`}
        >
            <div className="flex w-full min-w-0 flex-col items-start justify-center gap-4 text-[#181819] lg:gap-5">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.7, delay: 0.25 }}
                    className="
            w-full min-w-0 
            font-['Roboto_Mono',monospace]
            text-[16px] leading-[24px] tracking-[0.32px]
            lg:text-[18px] lg:leading-[30px]
            xl:text-[20px] xl:leading-[32px] xl:tracking-[0.4px]
          "
                >
                    <p className="mb-0">
                        <span>Porque Stacy nunca fue solo un lugar.</span>
                        <span className="font-bold"> Es un punto de encuentro.</span>
                        <span> Y aunque empezamos haciendo burgers, entendimos que hoy somos</span>
                        <span className="font-bold"> mucho mas. </span>
                        <span>No solo somos hamburguesas. Eso seria etiquetarnos. Y como dicen por ahi: </span>
                        <span className="font-bold">si te defino te limito.</span>
                    </p>

                    <p className="mb-0 mt-4 lg:mt-6">
                        <span>Stacy es</span>
                        <span className="font-bold"> ese momento compartido.</span>
                        <span> Esa ranchada donde las risas se mezclan con las historias.</span>
                        <span className="font-bold"> El punto de encuentro,</span>
                        <span> la previa, esa ranchada que se arma alrededor de la mesa.</span>
                        <span className="font-bold"> El ritual de compartir</span>
                        <span> con la excusa perfecta para quedarse un rato más.</span>
                    </p>

                    <p className="mb-0 mt-4 lg:mt-6">
                        <span>Porque al final, lo que importa no es ganar.</span>
                        <span className="font-bold"> Es jugar juntos.</span>
                        <span> Compartir la pasión de jugar. Y nunca, nunca perder el</span>
                        <span className="font-bold"> hambre de soñar.</span>
                    </p>
                </motion.div>
            </div>
        </motion.div>
    );
}

export default function AboutContent({ className = "" }: AboutSectionProps) {
    const sectionRef = useRef<HTMLElement>(null);

    const { scrollYProgress } = useScroll({
        target: sectionRef,
        offset: ["start end", "end start"],
        layoutEffect: false,
    });

    const mainImageY = useTransform(scrollYProgress, [0, 1], [30, -30]);
    const thumbnailsY = useTransform(scrollYProgress, [0, 1], [20, -20]);
    const textY = useTransform(scrollYProgress, [0, 1], [15, -15]);

    const opacity = useTransform(
        scrollYProgress,
        [0, 0.15, 0.85, 1],
        [0, 1, 1, 0]
    );
    const scale = useTransform(
        scrollYProgress,
        [0, 0.15, 0.85, 1],
        [0.96, 1, 1, 0.98]
    );

    return (
        <section
            id="about"
            ref={sectionRef}
            className={`relative w-full bg-[#f2f1de] px-4 py-[60px] sm:px-6 sm:py-[70px] md:px-8 lg:px-10 lg:py-[140px] xl:px-16 ${className}`}
            data-name="About Section"
        >
            <motion.div
                style={{ opacity, scale }}
                className="mx-auto w-full max-w-[1920px]"
            >
                <div
                    className="
            flex w-full flex-col gap-[48px]
            lg:gap-[56px]
            xl:flex-row xl:items-center xl:justify-between xl:gap-[40px]
            2xl:gap-[64px]
          "
                >
                    <AboutText textY={textY} />
                    <AboutImages
                        mainImageY={mainImageY}
                        thumbnailsY={thumbnailsY}
                    />


                </div>
            </motion.div>
            <motion.div
                style={{ opacity, scale }}
                className="mx-auto w-full max-w-[1920px] mt-24"
            >
                <div
                    className="
            flex w-full flex-col gap-[48px]
            lg:gap-[56px]
            xl:flex-row xl:items-center xl:justify-between xl:gap-[40px]
            2xl:gap-[64px]
          "
                >
                    <AboutText2
                        textY={textY}
                        className="order-1 xl:order-2"
                    />
                    <AboutImages2
                        mainImage2Y={mainImage2}
                        thumbnails2Y={thumbnailsY}
                        className="order-2 xl:order-1"
                    />


                </div>
            </motion.div>
        </section>
    );
}